<template>
    <v-card v-if="!loading">
        <v-data-table 
            :items="items" 
            :items-per-page="10" 
            :footer-props="{'items-per-page-options': [10, 50, 100, 200, -1]}"
            :headers="headers"
            :search="search"
            :custom-filter="customSearch"> 
            <template v-slot:item="props">
                <tr>
                    <td>{{ props.item.akcd_nr }}</td>
                    <td>{{ props.item.akcd_oms }}</td>
                    <td>{{ props.item.akcd_unique_akcc }}</td>
                    <td>{{ props.item.akcd_verk_kort }}</td>
                    <td>{{ props.item.bedr_codes }}</td>
                    <td>{{ props.item.land_codes }}</td>
                    <td>
                        {{ props.item.akcd_rules_count }} 
                        <v-icon color="red" icon="mdi-exclamation-thick" v-if="props.item.akcd_rules_count===0">mdi-exclamation-thick</v-icon> 
                        <btn_component type="text" text="Rules" color="primary" tooltip="View, add & delete rules" size="x-small" :data="props.item" @actionClick="updateRules" />
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-avatar class="mx-2 white--text avatar" color="primary" size="20" v-bind="attrs" v-on="on">i</v-avatar>
                            </template>
                            <span v-html="props.item.akcd_rules_text"></span>
                        </v-tooltip>
                    </td>
                    <td>
                        {{ props.item.akcd_codes_count }} 
                        <v-icon color="red" icon="mdi-exclamation-thick" v-if="props.item.akcd_codes_count===0">mdi-exclamation-thick</v-icon> 
                        <btn_component type="text" text="Codes" color="primary" tooltip="View, add & delete codes" size="x-small" :data="props.item" @actionClick="updateCodes" />
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-avatar class="mx-2 white--text avatar" color="primary" size="20" v-bind="attrs" v-on="on">i</v-avatar>
                            </template>
                            <span v-html="props.item.akcd_codes_text"></span>
                        </v-tooltip>
                    </td>
                    <!-- <td><longTextView :long_text="props.item.wzvz_veldwaarde_oud" :max_width="250"/></td>
                    <td><longTextView :long_text="props.item.wzvz_veldwaarde_nieuw" :max_width="250"/></td> -->
                    <td>
                        <btn_component type="text" text="Update" color="primary" tooltip="Update discount details" size="x-small" :data="props.item.akcd_encrid" @actionClick="updAkcd" />
                        <btn_component type="icon" icon="mdi-trash-can-outline" color="red" tooltip="Delete" size="small" data="" @actionClick="deleteAkcd(props.item.akcd_encrid, props.item.akcd_oms)" />
                    </td>
                </tr>
            </template>
        </v-data-table>
        <akcd_rmAkcd ref="akcd_rmAkcd" @refreshList="listAkcd"/>
        <akcd_updAkcd ref="akcd_updAkcd" @refreshList="listAkcd"/>
        <akcd_rules ref="akcd_rules" @refreshList="listAkcd"/>
        <akcd_codes ref="akcd_codes" @refreshList="listAkcd"/>
    </v-card>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    // import longTextView from "@/components/ui/fields/longTextView.vue";
    import akcd_rmAkcd from "@/components/syst/ref/akcd/akcd_rmAkcd.vue";
    import akcd_updAkcd from "@/components/syst/ref/akcd/akcd_updAkcd.vue";
    import akcd_rules from "@/components/syst/ref/akcd/akcd_rules.vue";
    import akcd_codes from "@/components/syst/ref/akcd/akcd_codes.vue";

    export default {
        components: {
            btn_component,
            // longTextView,
            akcd_rmAkcd,
            akcd_updAkcd,
            akcd_rules,
            akcd_codes,
        },
        props: {
        },    
        data() {
            return { 
                loading: true,

                search: "",
                unique: "",
                company: "",
                country: "",

                headers: [
                    { text: "nr", value: "akcd_nr", width: "5%" },
                    { text: "Description", value: "akcd_oms", width: "30%" },
                    { text: "Unique", value: "akcd_unique_akcc", width: "5%" },
                    { text: "Short desc", value: "akcd_verk_kort", width: "10%" },
                    { text: "Companies", value: "bedr_codes", width: "7%" },
                    { text: "Countries", value: "land_codes", width: "7%" },
                    { text: "Rules", value: "akcd_akcc_rules", width: "10%" },
                    { text: "Codes", value: "akcd_akcc_codes", width: "10%" },
                    { text: "Actions" },
                ],

                items: [],
                allitems: [],
            }
        },  
        mounted() {
            this.listAkcd();
        },
        methods: {
            customSearch (value, search, item) {
                return Object.values(item).some(v=>v&&v.toString().toLowerCase().includes(search.toLowerCase()))
            },
            listAkcd() {
                this.loading = true;
                this.$axios.post("ares/json/ares/syst/ref/akcd/searchAkcdv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "searchAkcd"
                    },
                    searchAkcd: {
                    }
                }).then(res => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        this.allitems = res.data.searchAkcd;
                        this.items = res.data.searchAkcd;
                        this.loading = false;
                    }
                });
            },
            updateSelection(selectionType, selectionValue) {
                // console.log(selectionType);
                // console.log(selectionValue);
                switch (selectionType) {
                    case "refresh":
                        this.listAkcd();
                        break;
                    case "search":
                        this.search = selectionValue;
                        break;
                    case "unique":
                        this.unique = selectionValue;
                        this.filterAll();
                        break;
                    case "company":
                        this.company = selectionValue;
                        this.filterAll();
                        break;
                    case "country":
                        this.country = selectionValue;
                        this.filterAll();
                        break;
                
                    default:
                        break;
                }
            },
            updAkcd(akcd_encrid) {
                this.$refs.akcd_updAkcd.openDialog(akcd_encrid);
            },
            updateRules(akcd) {
                //console.log(akcd);
                this.$refs.akcd_rules.openDialog(akcd);
            },
            updateCodes(akcd) {
                //console.log(codes);
                this.$refs.akcd_codes.openDialog(akcd);
            },
            deleteAkcd(akcd_encrid, akcd_oms) {
                this.$refs.akcd_rmAkcd.openDialog(akcd_encrid, akcd_oms);
            },
            filterAll() {
                this.items = [];
                for (let iIndex=0; iIndex<this.allitems.length; iIndex++) {
                    let ok = true;
                    if ((this.unique !== "")&&(this.unique !== this.allitems[iIndex].akcd_unique_akcc)) {
                        ok = false;
                    }
                    if (!this.allitems[iIndex].bedr_codes.includes(this.company)) {
                        ok = false;
                    }
                    if (!this.allitems[iIndex].land_codes.includes(this.country)) {
                        ok = false;
                    }
                    if (ok) {
                        this.items.push(this.allitems[iIndex]);
                    }
                } 
            },
            filterUnique() {
                if (this.unique === "") {
                    this.items = this.allitems;
                    return;
                }
                this.items = [];
                for (let iIndex=0; iIndex<this.allitems.length; iIndex++) {
                    if (this.unique === this.allitems[iIndex].akcd_unique_akcc) {
                        this.items.push(this.allitems[iIndex])
                    }
                }
            },
        }
    }
</script>

<style scoped> 
    .avatar {
        cursor: pointer;
    }
</style>